import {ReactNode} from 'react';

interface IProps {
  className?: string;
  children: ReactNode;
  title?: string;
  label: string;
}

export default function FloatingDevItem({
  className,
  children,
  title,
  label,
}: IProps) {
  return (
    <div className={cn('first:mt-0 mt-30', className)}>
      {title && <p className="s16-bold-white my-5">{title}</p>}
      <div className="flex items-center justify-between gap-x-40">
        <p className="s14-regular-white">{label}</p>
        {children}
      </div>
    </div>
  );
}
